
/**
 * LogoStylesProcessor - Creates styles for the logo section
 */
export class LogoStylesProcessor {
  static createLogoStyles(): string {
    return `
      .onexip-logo-container {
        padding: 1rem !important;
        display: flex !important;
        align-items: center !important;
        background-color: white !important;
        border-bottom: 1px solid #e5e7eb !important;
      }
      
      .onexip-logo {
        height: 2.5rem !important;
        max-height: 2.5rem !important;
        width: auto !important;
        display: block !important;
      }
    `;
  }
}
